import { Badge } from '../../components/badge'
import React from 'react'
import { labelStyle } from '@univdiam/ui/lib/tagColors'
import type { AdminTag } from './AddLabels'

type MoreLabelsProps ={
  orderId: string,
  HiddenTags:string[]
  adminTags?: AdminTag[]
}

function MoreLabels( {orderId, HiddenTags, adminTags = []} : MoreLabelsProps) {
  return (
    <div 
      className='bg-white py-3 pr-4  border rounded-sm shadow-sm transition-transform transform'
      onClick={(e) => e.stopPropagation()}
    >
      <div className='flex gap-4 items-center'>
        <span className="w-1 h-4.5 bg-blue-500 inline-block rounded-tr-sm rounded-br-sm"></span>
        <span className='text-caption1-bold'>More Labels</span>
      </div>
      <div className='pl-4 pt-2'>
        {
          HiddenTags.map((label, index) => (
            <Badge
              variant='outline'
              key={index}
              className='px-1.5 py-0.75 text-caption2 rounded-[4px] flex gap-1 inline-flex items-center mr-1 mb-1'
              style={labelStyle(label, adminTags)}
            >{label}</Badge>
        ))
        }
      </div>
    </div>
  )
}

export default MoreLabels